import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  entries: [
    {
      id: 1,
      date: '2026-03-25 13:00:00',
      matCode: '231112777',
      productName: 'ข้าวเหนียวไก่ย่างน้ำจิ้มแจ่ว',
      type: 'WIP',
      start: '13:10',
      end: '13:20',
      lot: '064',
      batch: '01',
      shift: 'D',
      weight: 128.1,
      qty: 100,
      unit: 'kg',
    },
  ],
};

const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    addEntry(state, action) {
      const nextId = state.entries.length ? Math.max(...state.entries.map(e => e.id)) + 1 : 1;
      state.entries.unshift({ id: nextId, ...action.payload });
    },
  },
});

export const { addEntry } = registerSlice.actions;
export default registerSlice.reducer;
